import { createMuiTheme } from '@material-ui/core/styles';

export const MATERIAL_UI_THEME = createMuiTheme({
    typography: {
        body1: { fontSize: '1rem' },
        body2: {
            fontSize: '1rem',
            fontWeight: 500,
        },
    },

    palette: {
        primary: { main: '#e4002b' },
    },

    overrides: {
        MuiCardHeader: {
            title: {
                fontSize: 16,
                lineHeight: '19px',
                letterSpacing: '0.15px',
                color: 'rgba(0, 0, 0, 0.87)',
            },
        },
    },
});
